import { render, staticRenderFns } from "./PgaOfferEvaluationCustomerOrderDetails.vue?vue&type=template&id=a3dd322a&scoped=true&"
import script from "./PgaOfferEvaluationCustomerOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationCustomerOrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PgaOfferEvaluationCustomerOrderDetails.vue?vue&type=style&index=0&id=a3dd322a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3dd322a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VDivider,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VExpansionPanels,VForm,VNavigationDrawer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3dd322a')) {
      api.createRecord('a3dd322a', component.options)
    } else {
      api.reload('a3dd322a', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationCustomerOrderDetails.vue?vue&type=template&id=a3dd322a&scoped=true&", function () {
      api.rerender('a3dd322a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/PgaOfferEvaluationCustomerOrderDetails.vue"
export default component.exports